import { ref } from 'vue'
import { listAgents } from '@/services/wootdashAgents'
import { toMediaUrl } from '@/utils/media'

// Foto de cada agente por id (Guid), pronta pra <img src>. Fonte única pras telas cujo payload só
// traz agentId/agentName (lista de conversas, avaliações, histórico do contato, cabeçalho) —
// sem isso cada uma mostrava só iniciais. Estado de módulo: carrega uma vez por sessão; trocar a
// própria foto (Meu perfil) chama setAgentAvatar e todas as telas atualizam na hora.

const avatars = ref<Record<string, string>>({})
let loadedFor = ''
let loading: Promise<void> | null = null

/** Idempotente por token: chame no onMounted de quem exibe avatar de agente. */
export function loadAgentAvatars(token: string): Promise<void> {
  if (!token) return Promise.resolve()
  if (loadedFor === token) return loading ?? Promise.resolve()
  loadedFor = token
  loading = listAgents(token)
    .then(({ agents }) => seedAgentAvatars(agents))
    .catch(() => { loadedFor = '' })
  return loading
}

/** Quem já buscou a lista de agentes (ex: dados ao vivo do Dashboard) alimenta o mapa sem nova requisição. */
export function seedAgentAvatars(agents: { id: string; avatarUrl: string | null }[]) {
  const next: Record<string, string> = { ...avatars.value }
  for (const a of agents) {
    const url = toMediaUrl(a.avatarUrl)
    if (url) next[a.id] = url
    else delete next[a.id]
  }
  avatars.value = next
}

/** avatarUrl cru da API (caminho relativo de POST /anexos) ou null pra tirar a foto. */
export function setAgentAvatar(agentId: string, avatarUrl: string | null) {
  seedAgentAvatars([{ id: agentId, avatarUrl }])
}

/** URL exibível ou null (sem foto / id que não é agente humano, ex: IA). */
export function agentAvatarUrl(agentId: string | null | undefined): string | null {
  return agentId ? avatars.value[agentId] ?? null : null
}

/** Sair da conta: a próxima pessoa na mesma aba carrega de novo. */
export function resetAgentAvatars() {
  loadedFor = ''
  loading = null
  avatars.value = {}
}
